import { Icon } from '@iconify/react';
import contactsFilled from '@iconify/icons-ant-design/contacts-fill';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Stack, Typography } from '@material-ui/core';
import { fShortenNumber } from '../../utils/formatNumber';
// utils

// ----------------------------------------------------------------------


const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  // textAlign: 'center',
  fontWeight: 'bold',
  padding: theme.spacing(2, 0, 2, 2),
  color: theme.palette.primary.darker,
  backgroundColor: theme.palette.primary.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: '50%',
  width: theme.spacing(6),
  height: theme.spacing(6),
  justifyContent: "center",
  //marginBottom: theme.spacing(2),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));


// ----------------------------------------------------------------------

const TOTAL = 714000;
const COLOR_SELECTED = {
  all: "#5cb85c"
}
export default function AnalytysStatistical({ value, title, channelSelected }) {
  return (
    <RootStyle sx={{ border: channelSelected ? '2px solid ' + COLOR_SELECTED[channelSelected] : 'none', }}>
      <Typography fontWeight={"bold"} variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>
      <Stack direction={"row"} spacing={2} sx={{ marginTop: 1 }}>
        <IconWrapperStyle>
          <Icon style={{ alignSelf: "center", color: channelSelected === "all" ? null : "grey" }} icon={contactsFilled} width={channelSelected === "all" ? 40 : 32} height={channelSelected === "all" ? 40 : 32} />
        </IconWrapperStyle>
        {/* <Typography alignSelf={"center"} variant="h3">{fShortenNumber(value)}</Typography> */}
        <Typography alignSelf={"center"} variant="h3">{value}</Typography>
      </Stack>
    </RootStyle>
  );
}
